import React from "react";
import {ButtonSubmit} from "./footer/styles";
import styled from "styled-components";

const DownTo = styled.div`
   width: 100%;
   padding-bottom: 1em;
   display: flex;
   justify-content: center;

   & img.iconDown {
      width: 1.6em;
      height: 1.6em;
   }

   @media screen and (max-width: 500px) {
      padding-bottom: 3em;
   }
`;

export default function DownArrow({goTo}) {
   return (
      <DownTo>
         <ButtonSubmit onClick={goTo} className="noHover">
            <img src={require("../assets/icons/down_bread.png")} alt="dwon" className="iconDown" />
         </ButtonSubmit>
      </DownTo>
   );
}

DownArrow.defaultProps = {
   goTo: () => {
      return false;
   },
};
